import axios from "axios";
const { API_BACKEND_HOST } = process.env;
import qs from "qs";

interface ISaveCompanyParams { 
    name: string;
    abbreviation: string;
    businessId: string;
}

interface IUpdateCompanyParams {
  id: string;
  data: {
    isActivated: boolean;
  }
} 

export const createCompany = async (data: ISaveCompanyParams) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data: responseData } = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Company`,
      data
  );

  return responseData;
};

export const updateCompany = async (id: string, data: ISaveCompanyParams) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data: responseData } = await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/Company/${id}`,
      data
  );

  return responseData;
};

export const updateCompanyStatus = async ({
  data, id
}: IUpdateCompanyParams) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data: responseData } = await axios.patch(
    `${API_BACKEND_HOST}${languageId}/v1/Company/${id}/activated`,
    data.isActivated // Envia apenas o valor booleano, não o objeto
  );

  return responseData;
};

export const getCompaniesByUser = async () => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data: responseData } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Company/CompaniesByUser`,
  );

  return responseData;
};

export const getCompaniesByCommittees = async (committeeIds: string[]) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data: responseData } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Company/CompaniesByCommittee`,
      {
        params: {
            ComiteInput: committeeIds,
        },
        paramsSerializer: params => {
            return qs.stringify(params)
        }
      }
  );

  return responseData;
};

